import { Box, styled } from "@mui/material";

export const StyledForm = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "1.5rem",
  "& .column-container": {
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
}));
